'use strict';
// from old site's js

const $ = require('jquery');

let shareButtons = {
  init: function() {
    $('html.v-2018 .share-buttons a').click(function(e) {
      if (!/linkedin\.com|^mailto/.test(this.href)) {
        e.preventDefault();
        let width = 675,
          height = 375,
          top = (window.innerHeight / 2) - (height / 2),
          left = (window.innerWidth / 2) - (width / 2);
        window.open(this.href, '_blank', 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left);
      }
    });
  }
};

export default shareButtons;
